
import { RequestedValue$1 } from "../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_completeTourStep, Cmd_getCompletedTourSteps, Cmd_getDemoDataImportAvailable } from "../Requests/Onboarding.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_errorToast } from "../Components/Toast.js";
import { Cmd_ofEffect } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export const init = [new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), false), Cmd_batch(ofArray([Cmd_getDemoDataImportAvailable((Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(2, [Item_1]))), Cmd_getCompletedTourSteps((Item_2) => (new Msg(1, [Item_2])), (Item_3) => (new Msg(2, [Item_3])))]))];

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(state.DemoImportAvailable, new RequestedValue$1(1, [msg.fields[0].CompletedSteps]), state.ShowRestApiTourInfoDialog), Cmd_none()];
        case 3: {
            const step = msg.fields[0];
            return [state, Cmd_completeTourStep(step, (r) => (new Msg(4, [step, r])), (Item) => (new Msg(5, [Item])))];
        }
        case 4: {
            const step_1 = msg.fields[0];
            const response = msg.fields[1];
            if (response.tag === 1) {
                return [state, Cmd_errorToast("validation.toast")];
            }
            else {
                const withSteps = new State(state.DemoImportAvailable, new RequestedValue$1(1, [response.fields[0].CompletedSteps]), state.ShowRestApiTourInfoDialog);
                switch (step_1) {
                    case "api-integrations-step":
                        return [new State(withSteps.DemoImportAvailable, withSteps.CompletedTourSteps, true), Cmd_none()];
                    case "create-inventory-step":
                        return [withSteps, Cmd_ofEffect((_arg) => {
                            RouterModule_nav(singleton("tools" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "create-inventory-step"]))), 1, 1);
                        })];
                    case "assign-tools-step":
                        return [withSteps, Cmd_ofEffect((_arg_1) => {
                            RouterModule_nav(singleton("tools" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "assign-tools-step"]))), 1, 1);
                        })];
                    case "filter-search-step":
                        return [withSteps, Cmd_ofEffect((_arg_2) => {
                            RouterModule_nav(singleton("tools" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "filter-search-step"]))), 1, 1);
                        })];
                    case "inspection-step":
                        return [withSteps, Cmd_ofEffect((_arg_3) => {
                            RouterModule_nav(singleton("inspection-templates" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "inspection-step"]))), 1, 1);
                        })];
                    case "category-labels-step":
                        return [withSteps, Cmd_ofEffect((_arg_4) => {
                            RouterModule_nav(ofArray(["settings", "categories" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "category-labels-step"]))]), 1, 1);
                        })];
                    case "manage-storages-step":
                        return [withSteps, Cmd_ofEffect((_arg_5) => {
                            RouterModule_nav(singleton("storages" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "manage-storages-step"]))), 1, 1);
                        })];
                    case "tenants-step":
                        return [withSteps, Cmd_ofEffect((_arg_6) => {
                            RouterModule_nav(singleton("dashboard" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "tenants-step"]))), 1, 1);
                        })];
                    case "chat-step":
                        return [withSteps, Cmd_ofEffect((_arg_7) => {
                            RouterModule_nav(ofArray(["settings", "permissions" + RouterModule_encodeQueryString(ofArray([["onboardingTourStep", "chat-step"], ["phase", "permissions"]]))]), 1, 1);
                        })];
                    case "stocktaking-step":
                        return [withSteps, Cmd_ofEffect((_arg_8) => {
                            RouterModule_nav(singleton("stocktaking" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "stocktaking-step"]))), 1, 1);
                        })];
                    case "business-units-step":
                        return [withSteps, Cmd_ofEffect((_arg_9) => {
                            RouterModule_nav(singleton("business-units" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "business-units-step"]))), 1, 1);
                        })];
                    case "set-bundles-step":
                        return [withSteps, Cmd_ofEffect((_arg_10) => {
                            RouterModule_nav(singleton("tools" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "set-bundles-step"]))), 1, 1);
                        })];
                    case "custom-fields-step":
                        return [withSteps, Cmd_ofEffect((_arg_11) => {
                            RouterModule_nav(ofArray(["settings", "custom-properties" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "custom-fields-step"]))]), 1, 1);
                        })];
                    case "who-has-what-step":
                        return [withSteps, Cmd_ofEffect((_arg_12) => {
                            RouterModule_nav(singleton("receivers" + RouterModule_encodeQueryString(singleton(["onboardingTourStep", "who-has-what-step"]))), 1, 1);
                        })];
                    default:
                        return [withSteps, Cmd_none()];
                }
            }
        }
        case 6:
            return [new State(state.DemoImportAvailable, state.CompletedTourSteps, false), Cmd_none()];
        case 5:
            return [state, Cmd_errorToast("general.a_error_occured")];
        case 2:
            return [state, Cmd_errorToast("general.a_error_occured")];
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0].Value]), state.CompletedTourSteps, state.ShowRestApiTourInfoDialog), Cmd_none()];
    }
}

